export const detailHeaderEffect = (clientId, classes, setHeaderClass) => () => {
  setHeaderClass(clientId ? classes.detailHeader : classes.detailHeaderMin);
};
